export default __webpack_public_path__ + "static/media/elephant-1.b9eb72c5.png";